import { characterPose } from './character-motion.js';
import { smoothMaskAlpha } from './edge-mask.js';
const W=1672,H=941;
const constructionCanvases=[];
function canvas(){const c=document.createElement('canvas');c.width=W;c.height=H;constructionCanvases.push(c);return c;}
function layer(left,top,width,height){const c=document.createElement('canvas');c.width=width;c.height=height;c.originX=left;c.originY=top;c.getContext('2d').translate(-left,-top);return c;}
function pathMask(path){const c=canvas(),x=c.getContext('2d');x.fillStyle='white';x.fill(new Path2D(path));return c;}
function ellipse(x,y,rx,ry){const c=canvas(),g=c.getContext('2d');g.fillStyle='white';g.beginPath();g.ellipse(x,y,rx,ry,0,0,Math.PI*2);g.fill();return c;}
function union(...masks){const c=canvas(),x=c.getContext('2d');masks.forEach(m=>x.drawImage(m,0,0));return c;}
function subtract(mask,...holes){const c=union(mask),x=c.getContext('2d');x.globalCompositeOperation='destination-out';holes.forEach(h=>x.drawImage(h,0,0));return c;}
function intersect(a,b){const c=union(a),x=c.getContext('2d');x.globalCompositeOperation='destination-in';x.drawImage(b,0,0);return c;}
function cut(image,mask){const c=canvas(),x=c.getContext('2d');x.drawImage(image,0,0,W,H);x.globalCompositeOperation='destination-in';x.drawImage(mask,0,0);return c;}
function mainIsland(mask){
 const c=union(mask),x=c.getContext('2d'),pixels=x.getImageData(0,0,W,H),labels=new Int32Array(W*H),queue=new Int32Array(W*H);
 let id=0,best=0,bestSize=0;
 for(let i=0;i<labels.length;i++)if(!labels[i]&&pixels.data[i*4+3]>32){
  id++;let end=1;queue[0]=i;labels[i]=id;
  for(let p=0;p<end;p++){const at=queue[p],col=at%W;
   for(const next of [col>0?at-1:-1,col<W-1?at+1:-1,at-W,at+W]){
    if(next>=0&&next<labels.length&&!labels[next]&&pixels.data[next*4+3]>32){labels[next]=id;queue[end++]=next;}
   }
  }
  if(end>bestSize){best=id;bestSize=end;}
 }
 for(let i=0;i<labels.length;i++)if(labels[i]!==best)pixels.data[i*4+3]=0;
 x.putImageData(pixels,0,0);return c;
}
function dilate(mask,r){const c=canvas(),x=c.getContext('2d');for(let a=0;a<8;a++)x.drawImage(mask,Math.cos(a*Math.PI/4)*r,Math.sin(a*Math.PI/4)*r);x.drawImage(mask,0,0);return c;}
function maskFromPixels(source,box,seeds,test,blackGrowth=3){
 const [left,top,width,height]=box,n=width*height,data=source.getContext('2d').getImageData(left,top,width,height).data;
 const selected=new Uint8Array(n),stack=new Int32Array(n);let end=0;
 for(const [sx,sy] of seeds){const i=(sy-top)*width+sx-left;if(i>=0&&i<n&&!selected[i]){selected[i]=1;stack[end++]=i;}}
 for(let p=0;p<end;p++){
  const i=stack[p],x=i%width,y=(i/width)|0;
  for(const j of [x>0?i-1:-1,x<width-1?i+1:-1,y>0?i-width:-1,y<height-1?i+width:-1]){
   if(j<0||selected[j])continue;const k=j*4;
   if(test(data[k],data[k+1],data[k+2])){selected[j]=1;stack[end++]=j;}
  }
 }
 for(let step=0;step<blackGrowth;step++){
  const copy=selected.slice();
  for(let i=width+1;i<n-width-1;i++)if(!selected[i]&&data[i*4]<70&&data[i*4+1]<50&&data[i*4+2]<55&&(copy[i-1]||copy[i+1]||copy[i-width]||copy[i+width]))selected[i]=1;
 }
 // Flood the exterior; enclosed eyes, logos and feather details remain part of the silhouette.
 const outside=new Uint8Array(n);end=0;
 for(let x=0;x<width;x++)for(const i of [x,(height-1)*width+x])if(!selected[i]&&!outside[i]){outside[i]=1;stack[end++]=i;}
 for(let y=0;y<height;y++)for(const i of [y*width,y*width+width-1])if(!selected[i]&&!outside[i]){outside[i]=1;stack[end++]=i;}
 for(let p=0;p<end;p++){const i=stack[p],x=i%width,y=(i/width)|0;for(const j of [x>0?i-1:-1,x<width-1?i+1:-1,y>0?i-width:-1,y<height-1?i+width:-1])if(j>=0&&!selected[j]&&!outside[j]){outside[j]=1;stack[end++]=j;}}
 const c=canvas(),g=c.getContext('2d'),pixels=g.createImageData(width,height);
 for(let i=0;i<n;i++)if(selected[i]||!outside[i])pixels.data.set([255,255,255,255],i*4);
 g.putImageData(smoothMaskAlpha(pixels),left,top);return c;
}
function overlay(base,repair,mask){base.getContext('2d').drawImage(cut(repair,mask),0,0);}
function matchedRepair(source,repair,mask,bounds){
 const [left,top,width,height]=bounds,c=canvas(),x=c.getContext('2d');x.drawImage(repair,0,0,W,H);
 const original=source.getContext('2d').getImageData(left,top,width,height).data;
 const patch=x.getImageData(left,top,width,height),inside=mask.getContext('2d').getImageData(left,top,width,height).data;
 const sums=[0,0,0];let count=0;
 for(let i=0;i<original.length;i+=4)if(inside[i+3]===0&&original[i]>original[i+1]*1.4&&original[i]>100){for(let k=0;k<3;k++)sums[k]+=original[i+k]-patch.data[i+k];count++;}
 if(count)for(let i=0;i<patch.data.length;i+=4)for(let k=0;k<3;k++)patch.data[i+k]+=sums[k]/count;
 x.putImageData(patch,left,top);return c;
}
async function load(name){const img=new Image();img.src=`./public/reference-rig/${name}`;await img.decode();return img;}
function blink(t,offset=0){const p=(t+offset)%6.3;if(p>4.6&&p<4.84)return Math.max(.045,Math.abs(p-4.72)/.12);return 1;}

export async function createSourceRig(original,onPrepared){
 const [background,features,wingRepair]=await Promise.all([load('background-repair.png'),load('feature-repair.png'),load('bird-wing-repair.png')]);
 const source=canvas();source.getContext('2d').drawImage(original,0,0,W,H);
 const red=(r,g,b)=>r>90&&r>g*1.25&&r>b*1.12&&b>g*.53;
 const characterMask=maskFromPixels(source,[510,145,299,519],[[650,320],[650,535],[579,567],[767,555],[645,623],[735,615],[701,156],[662,197],[555,253],[773,285]],red,8);
 const propMask=maskFromPixels(source,[735,429,227,164],[[833,512],[920,465],[760,571]],(r,g,b)=>(r>80&&r>g*1.1&&g>b*1.2)||(r>180&&g>130&&r>g*.98&&g>b*1.03),4);
 // Only the shoulder is a cut line; the rest of this mask stays outside the hand's ink.
 const armMask=pathMask('M696 510 L816 510 L816 587 L759 587 L745 581 L724 574 L709 570 Q718 548 696 510 Z');
 const eyes=[ellipse(598,386,33,42),ellipse(730,398,33,42)];
 const mouth=pathMask('M609 437 Q611 430 621 434 Q657 446 694 440 Q714 439 708 456 Q699 480 663 485 Q630 486 616 465 Q609 452 609 437 Z');
 const face=union(...eyes,mouth);
 const body=union(source);
 eyes.forEach((eye,i)=>overlay(body,matchedRepair(source,features,eye,i?[694,354,74,90]:[561,340,75,90]),eye));
 const mouthRepair=dilate(mouth,4);
 overlay(body,matchedRepair(source,features,mouthRepair,[598,422,120,72]),mouthRepair);
 const shoulderOverlap=intersect(characterMask,ellipse(710,541,12,22));
 // The butt of the stick is visually separated by the fingers, but belongs to the same rig.
 const stickButt=pathMask('M759 554 L768 560 L750 587 L741 581 Z');
 // Sampled from the outer chin ink in the approved source, excluding the shoulder line.
 const jaw=[[805,431],[785,459],[775,473],[765,484],[750,495],[735,503],[715,509],[695,513],[675,514],[655,514],[635,511],[615,507],[600,502],[590,498],[580,494],[560,481],[540,461],[515,441]];
 let jawPath='M500 130 L820 130 L820 420 L805 431';
 for(let i=0;i<jaw.length-1;i++){
  const a=jaw[Math.max(0,i-1)],b=jaw[i],c=jaw[i+1],d=jaw[Math.min(jaw.length-1,i+2)];
  jawPath+=` C${b[0]+(c[0]-a[0])/6} ${b[1]+(c[1]-a[1])/6} ${c[0]-(d[0]-b[0])/6} ${c[1]-(d[1]-b[1])/6} ${c[0]} ${c[1]}`;
 }
 const headRegion=pathMask(jawPath+' L500 420 Z'),headMask=intersect(characterMask,headRegion);
 const freeArmMask=subtract(intersect(characterMask,pathMask('M588 507 L619 521 Q615 535 610 549 Q606 559 612 574 Q616 591 600 598 Q589 600 580 604 L566 607 L541 605 L538 554 Z')),dilate(headMask,4));
 const restBody=mainIsland(subtract(union(subtract(characterMask,armMask),shoulderOverlap),propMask,stickButt));
 const neckCleanup=pathMask('M595 496 L723 496 L723 525 L615 525 L595 517 Z');
 const nc=neckCleanup.getContext('2d'),neckFade=nc.createLinearGradient(0,516,0,525);
 neckFade.addColorStop(0,'white');neckFade.addColorStop(1,'transparent');nc.globalCompositeOperation='destination-in';nc.fillStyle=neckFade;nc.fillRect(0,0,W,H);
 let bodySprite=cut(body,mainIsland(subtract(restBody,dilate(headRegion,1.5),dilate(freeArmMask,1),neckCleanup)));
 const torsoSource=bodySprite.getContext('2d').getImageData(570,500,96,102).data;
 const headSprite=cut(body,headMask),freeArmSprite=cut(source,freeArmMask);
 const restingTorso=cut(body,mainIsland(subtract(restBody,headRegion)));
 const jointSprite=canvas(),joint=jointSprite.getContext('2d');
 const neckPath=new Path2D('M596 490 L650 485 L716 503 L716 536 L610 543 L590 515 Z');
 const jointColor=joint.createLinearGradient(590,510,670,590);jointColor.addColorStop(0,'#ca2639');jointColor.addColorStop(1,'#e93240');
 joint.fillStyle=jointColor;
 const torsoSide='M596 497 C587 524 583 553 585 577 Q586 592 590 602';
 const torsoShape=pathMask(torsoSide+' L570 680 L820 680 L820 495 Z');
 joint.strokeStyle='#1c1011';joint.lineWidth=3.5;
 joint.fill(new Path2D(torsoSide+' L651 618 L682 550 L644 497 Z'));
 bodySprite=union(jointSprite,bodySprite);
 // Reconstruct the entire exposed flank, stopping above the original leg ink.
 const torsoRepair=union(body),tr=torsoRepair.getContext('2d');
 const skin=tr.getImageData(570,500,96,102);
 // Start the blend beyond the old arm: its red shading can leave a ghost even
 // after its dark ink is removed. One continuous field also avoids patch seams.
 tr.fillStyle=jointColor;tr.fillRect(570,500,96,102);
 const flank=tr.getImageData(570,500,96,102).data;
 const legSkin=body.getContext('2d').getImageData(570,602,96,1).data;
 for(let y=0;y<102;y++)for(let x=0;x<64;x++){
  // Never blend source art back into a removed head/arm pixel. Preserve the
  // neck cleanup's partial coverage too, so its feather stays continuous.
  const i=(y*96+x)*4,a=Math.max(0,Math.min(1,(x+570-618)/16)),blend=a*a*(3-2*a)*torsoSource[i+3]/255;
  const v=Math.max(0,Math.min(1,(y+500-550)/52)),legBlend=v*v*(3-2*v);
  const legX=Math.max(28,x),legIndex=legX*4;
  // The lower boundary must match the real leg, not end at a hand-shaped mask.
  // Retain the source leg's ink independently of its surrounding red shading.
  const legInk=x+570>=616&&y+500>=576&&torsoSource[i+3]===255&&skin.data[i]<160&&skin.data[i+1]<80;
  if(legInk)continue;
  for(let k=0;k<3;k++){
   const shade=flank[i+k]*(1-legBlend)+legSkin[legIndex+k]*legBlend;
   skin.data[i+k]=shade*(1-blend)+skin.data[i+k]*blend;
  }
 }
 tr.putImageData(skin,570,500);
 const torsoRepairMask=intersect(bodySprite,pathMask('M570 500 L634 500 L634 602 L570 602 Z'));
 overlay(bodySprite,torsoRepair,torsoRepairMask);
 // The uncovered side is a torso, not the silhouette of the old hanging hand.
 bodySprite=cut(bodySprite,torsoShape);
 const sideInk=canvas(),si=sideInk.getContext('2d');si.strokeStyle='#1c1011';si.lineWidth=3.5;si.lineCap='round';si.stroke(new Path2D(torsoSide));
 si.globalCompositeOperation='destination-out';si.fill(neckPath);
 const bodyEdge=bodySprite.getContext('2d');bodyEdge.globalCompositeOperation='source-over';bodyEdge.drawImage(sideInk,0,0);
 // Both poses own exactly the same lower-body pixels. The arm/torso cut must
 // never reshape the planted leg, even when a tiny warming pose selects it.
 bodyEdge.clearRect(0,602,W,H-602);
 bodyEdge.drawImage(restingTorso,588,602,W-588,H-602,588,602,W-588,H-602);
 freeArmSprite.getContext('2d').clearRect(588,602,W-588,H-602);
 const restingRig=union(bodySprite,freeArmSprite);
 onPrepared?.({headSprite,bodySprite,freeArmSprite,restingTorso});
 const armSprite=cut(source,union(mainIsland(union(intersect(characterMask,armMask),propMask)),stickButt));
 const birdMask=maskFromPixels(source,[107,435,139,150],[[190,461],[192,523],[152,529],[123,546],[136,551]],(r,g,b)=>Math.abs(r-g)<32&&g-b<39&&r>65,4);
 // Trace the complete toes, including their dark ink and shaded orange pixels.
 const feet=pathMask('M165 559 L175 559 L175 566 Q183 567 186 571 Q188 575 185 578 L177 575 L175 575 Q175 580 171 580 Q166 580 166 575 L157 576 Q153 575 156 571 Q159 568 165 566 Z M195 557 L203 557 L205 564 Q216 564 220 568 Q223 571 222 574 L215 574 L211 572 L211 575 Q209 577 207 576 L199 573 L192 572 Q189 571 191 568 L197 566 Z');
 const fullBird=union(birdMask,feet);
 const wing=pathMask('M132 532 Q141 514 161 509 Q178 503 181 516 Q184 539 162 551 Q152 558 139 555 L142 542 L132 542 Z');
 const birdEyes=[pathMask('M173 474 L201 487 Q199 498 184 497 Q169 493 173 474 Z'),pathMask('M212 486 L232 472 Q240 486 229 495 L216 497 Z')];
 const birdBody=union(source);overlay(birdBody,wingRepair,wing);overlay(birdBody,features,union(...birdEyes));
 const birdSprite=cut(birdBody,fullBird),wingSprite=cut(source,wing);
 const fireCanvas=canvas(),fc=fireCanvas.getContext('2d'),firePixels=source.getContext('2d').getImageData(887,492,281,339),fp=fc.createImageData(281,339);
 for(let i=0;i<firePixels.data.length;i+=4){const [r,g,b]=firePixels.data.slice(i,i+3),x=887+(i/4)%281,y=492+Math.floor(i/4/281);if(!(x<960&&y<600)&&r>226&&g>122&&g>b*1.15&&b<205)fp.data.set([255,255,255,255],i);}
 fc.putImageData(smoothMaskAlpha(fp),887,492);const fireMask=dilate(fireCanvas,.7),fireSprite=cut(source,fireMask);
 const base=union(source);overlay(base,background,union(dilate(characterMask,2),dilate(propMask,4),dilate(fullBird,2),dilate(fireMask,1)));
 const armBackdrop=canvas();armBackdrop.getContext('2d').drawImage(background,-90,0,W,H);
 // The repair plate invents a tall log tip behind the jaw. Continue its adjacent foliage
 // through the exposed head sweep instead; this changes the backdrop, not the face edge.
 const jawBackdrop=intersect(dilate(headMask,4),pathMask('M710 452 Q755 450 798 425 L816 492 L760 524 L710 532 Z'));
 overlay(base,armBackdrop,jawBackdrop);
 overlay(base,armBackdrop,dilate(intersect(characterMask,armMask),4));
 overlay(base,armBackdrop,pathMask('M735 567 L758 567 L767 592 L735 597 Z'));
 // The lake's horizontal texture can continue behind the removed prop without a silhouette-shaped repair seam.
 const bx=base.getContext('2d'),lake=bx.getImageData(880,424,90,80);
 const cleanWater=source.getContext('2d').getImageData(975,424,90,80).data;
 for(let y=0;y<80;y++)for(let x=0;x<90;x++){
  const i=(y*90+x)*4,a=Math.min(1,x/8,(89-x)/8,y/8,(79-y)/8);
  for(let k=0;k<3;k++)lake.data[i+k]=lake.data[i+k]*(1-a)+cleanWater[i+k]*a;
 }
 bx.putImageData(lake,880,424);
 const actor=layer(495,125,490,555),owl=layer(100,430,155,160);
 const eyeSprites=eyes.map(m=>cut(source,m)),mouthSprite=cut(source,mouth),birdEyeSprites=birdEyes.map(m=>cut(source,m));
 let wingAmount=0,lastMs=0,diagnostics={};
 // Cache tightly cropped textures once, rather than transform full-scene surfaces.
 const textures=new Map();
 for(const c of [restingRig,restingTorso,bodySprite,headSprite,freeArmSprite,armSprite,...eyeSprites,mouthSprite,birdSprite,wingSprite,...birdEyeSprites]){
  const pixels=c.getContext('2d').getImageData(0,0,W,H).data;
  let left=W,top=H,right=0,bottom=0;
  for(let y=0;y<H;y++)for(let x=0;x<W;x++)if(pixels[(y*W+x)*4+3]){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);}
  // Pose changes must sample the identical planted pixels from the same texture
  // origin, otherwise subpixel breathing can shift their rasterized edge.
  if(c===restingRig||c===restingTorso||c===bodySprite){left=535;top=480;right=819;bottom=679;}
  const texture=document.createElement('canvas');texture.width=right-left+1;texture.height=bottom-top+1;
  texture.getContext('2d').drawImage(c,left,top,texture.width,texture.height,0,0,texture.width,texture.height);
  const alpha=new Uint8Array(texture.width*texture.height);
  for(let y=0;y<texture.height;y++)for(let x=0;x<texture.width;x++)alpha[y*texture.width+x]=pixels[((y+top)*W+x+left)*4+3];
  textures.set(c,{texture,left,top,alpha});
 }
 function sprite(ctx,c){const {texture,left,top}=textures.get(c);ctx.drawImage(texture,left,top);}
 function transformed(ctx,c,cx,cy,sx,sy,angle=0,dx=0,dy=0){ctx.save();ctx.translate(cx+dx,cy+dy);ctx.rotate(angle);ctx.scale(sx,sy);ctx.translate(-cx,-cy);sprite(ctx,c);ctx.restore();}
 const whiteTextures=new Map();
 for(const c of [restingRig,restingTorso,bodySprite,headSprite,freeArmSprite,armSprite,birdSprite,wingSprite]){
  const {texture,left,top}=textures.get(c),white=document.createElement('canvas');
  white.width=texture.width+8;white.height=texture.height+8;const x=white.getContext('2d');
  x.drawImage(texture,4,4);
  for(let a=0;a<16;a++)x.drawImage(texture,4+Math.cos(a*Math.PI/8)*1.2,4+Math.sin(a*Math.PI/8)*1.2);
  x.globalCompositeOperation='source-in';x.fillStyle='#fffef4';x.fillRect(0,0,white.width,white.height);
  const soft=document.createElement('canvas');soft.width=white.width;soft.height=white.height;
  const sx=soft.getContext('2d');sx.filter='blur(.55px)';sx.drawImage(white,0,0);
  whiteTextures.set(c,{white:soft,left:left-4,top:top-4});
 }
 function whiteSprite(ctx,c){const {white,left,top}=whiteTextures.get(c);ctx.drawImage(white,left,top);}
 const actorOutline=layer(495,125,490,555),birdOutline=layer(100,430,155,160);
 function headTransform(ctx,pose){
  ctx.translate(659+pose.headX,505+pose.headY);ctx.rotate(pose.headAngle);ctx.scale(pose.headScaleX,1);ctx.translate(-659,-505);
 }
 function freeArmTransform(ctx,pose){
  ctx.translate(588,507+pose.freeArmY);ctx.rotate(pose.freeArmAngle);ctx.translate(-588,-507);
 }
 function drawNeck(ctx,outline=false){
  ctx.fillStyle=outline?'#fffef4':jointColor;ctx.fill(neckPath);
 }
 function removeInterior(outline,subject){
  const x=outline.getContext('2d');x.globalCompositeOperation='destination-out';
  x.drawImage(subject,subject.originX,subject.originY);x.globalCompositeOperation='source-over';
 }
 // The original flame deformation repeats every pi/2 seconds. Cache its 48 phases.
 const flameFrames=Array.from({length:48},(_,i)=>{
  const c=layer(880,490,300,345),fx=c.getContext('2d'),phase=i*Math.PI*2/48;
  for(let y=492;y<831;y+=2){const weight=Math.max(0,(810-y)/318),shift=(Math.sin(phase+y*.03)-Math.sin(y*.03))*3*weight;fx.drawImage(fireSprite,882,y,294,2,882+shift,y,294,2);}
  return c;
 });
 function frame(ms,hover,paused,night=0){
  const t=ms/1000,dt=Math.min(Math.abs(ms-lastMs)/1000,.25);lastMs=ms;
  const pose=characterPose(ms,night);
  wingAmount+=((hover==='bird'?1:0)-wingAmount)*(1-Math.exp(-10*dt));
  const ac=actor.getContext('2d');ac.clearRect(0,0,W,H);ac.save();
  const breathe=Math.sin(t*1.5)*.002;
  ac.translate(665,653);ac.scale(1+breathe*.28,1+breathe);ac.translate(-665,-653);
  drawNeck(ac);
  // Keep a single torso through zero pose; swapping to baked resting artwork
  // introduces a visible neck/flank pop at both ends of the warming gesture.
  if(pose.warm>0){sprite(ac,bodySprite);ac.save();freeArmTransform(ac,pose);sprite(ac,freeArmSprite);ac.restore();}
  else sprite(ac,restingRig);
  // Finish the exposed shoulder after the overlapping torso and arm fills.
  ac.save();ac.globalCompositeOperation='source-atop';ac.strokeStyle='#1c1011';ac.lineWidth=7;
  ac.lineCap='round';ac.beginPath();ac.moveTo(594,496);ac.lineTo(591,506);ac.stroke();ac.restore();
  const armAngle=Math.sin(t*.72)*.055;
  transformed(ac,armSprite,709,535,1,1,armAngle);
  ac.save();headTransform(ac,pose);sprite(ac,headSprite);
  eyeSprites.forEach((sprite,i)=>{
   const cx=i?730:598,cy=i?398:386,amount=blink(t);
   const eyeScale=i?1+pose.look*.025:1-pose.look*.12;
   const dx=pose.faceX+pose.gazeX+Math.sin(t*.48)*1.1,dy=pose.faceY+pose.gazeY;
   if(amount>.15)transformed(ac,sprite,cx,cy,eyeScale,amount,0,dx,dy);
   else {ac.strokeStyle='#211313';ac.lineWidth=2.3;ac.lineCap='round';ac.beginPath();ac.moveTo(cx+dx-24*eyeScale,cy+dy);ac.quadraticCurveTo(cx+dx,cy+dy+5,cx+dx+24*eyeScale,cy+dy);ac.stroke();}
  });
  const mouthX=659+pose.faceX*.9,mouthY=454+pose.faceY;
  ac.save();ac.globalAlpha=1-pose.blow;
  transformed(ac,mouthSprite,659,446,(1-pose.look*.045)*(1-pose.blow*.6),(1+Math.sin(t*.5)*.018)*(1-pose.blow*.5),0,pose.faceX*.9,pose.faceY);
  ac.restore();
  if(pose.blow>0){
   ac.save();ac.globalAlpha=pose.blow;ac.fillStyle='#56141f';ac.strokeStyle='#211313';ac.lineWidth=2;
   ac.beginPath();ac.ellipse(mouthX+9,mouthY,6.5,8.5,0,0,Math.PI*2);ac.fill();ac.stroke();
   ac.strokeStyle='#f97c7a';ac.lineWidth=1.5;ac.beginPath();ac.ellipse(mouthX+9,mouthY+1,9,11,0,.2,1.9);ac.stroke();
   ac.restore();
  }
  ac.restore();
  if(pose.blow>.02){
   // Short drawn breath strokes travel toward the prop, with no particles or physics.
   ac.save();ac.strokeStyle='#fff9e8';ac.lineWidth=2.2;ac.lineCap='round';
   const lipDX=(mouthX+9-659)*pose.headScaleX,lipDY=mouthY-505;
   const lipX=659+pose.headX+lipDX*Math.cos(pose.headAngle)-lipDY*Math.sin(pose.headAngle);
   const lipY=505+pose.headY+lipDX*Math.sin(pose.headAngle)+lipDY*Math.cos(pose.headAngle);
   for(let i=0;i<3;i++){
    const travel=(pose.puffPhase+i*.21)%1,fade=Math.sin(travel*Math.PI)*pose.blow;
    const x=lipX+12+travel*135,y=lipY+(i-1)*6;
    ac.globalAlpha=fade*.8;ac.beginPath();ac.moveTo(x,y);ac.bezierCurveTo(x+9,y-3,x+22,y+3,x+30,y-1);ac.stroke();
   }
   ac.restore();
  }
  ac.restore();
  const oc=owl.getContext('2d');oc.clearRect(0,0,W,H);sprite(oc,birdSprite);
  const wingAngle=Math.sin(t*9)*.16*wingAmount;
  transformed(oc,wingSprite,173,516,1,1,wingAngle);
  birdEyeSprites.forEach((sprite,i)=>transformed(oc,sprite,i?224:188,487,1,blink(t,2.1)));
  const flame=flameFrames[((Math.round(t*4/(Math.PI*2)*48)%48)+48)%48];
  let outline=null;
  if(hover==='sparky'){
   const x=actorOutline.getContext('2d');x.clearRect(0,0,W,H);x.save();
   x.translate(665,653);x.scale(1+breathe*.28,1+breathe);x.translate(-665,-653);
   drawNeck(x,true);
   whiteSprite(x,bodySprite);x.save();freeArmTransform(x,pose);whiteSprite(x,freeArmSprite);x.restore();
   x.save();headTransform(x,pose);whiteSprite(x,headSprite);x.restore();
   x.translate(709,535);x.rotate(armAngle);x.translate(-709,-535);whiteSprite(x,armSprite);
   x.restore();removeInterior(actorOutline,actor);outline=actorOutline;
  }else if(hover==='bird'){
   const x=birdOutline.getContext('2d');x.clearRect(0,0,W,H);whiteSprite(x,birdSprite);x.save();
   x.translate(173,516);x.rotate(wingAngle);x.translate(-173,-516);whiteSprite(x,wingSprite);
   x.restore();removeInterior(birdOutline,owl);outline=birdOutline;
  }
  diagnostics={breathe,armAngle,blink:blink(t),birdBlink:blink(t,2.1),wingAngle,wingAmount,...pose};
  return {base,actor,owl,flame,outline};
 }
 const chestBounds=pathMask('M1450 623 Q1457 578 1478 557 Q1497 547 1529 552 L1651 569 Q1665 573 1672 580 L1672 785 L1450 785 Z');
 const chestFlood=intersect(maskFromPixels(source,[1443,547,229,241],[[1510,650],[1510,700],[1510,737],[1600,710],[1540,600],[1490,580]],(r,g,b)=>r>65&&r>g*1.09&&g>b*1.13,3),chestBounds);
 // The lid crosses similarly colored tent pixels; trace its continuous painted
 // silhouette instead of allowing the color flood to pick up tent fragments.
 const chestLid=pathMask('M1450 640 L1450 612 L1453 611 C1460 585 1480 563 1499 556 C1508 552 1526 555 1538 556 L1647 567 Q1660 564 1672 567 L1672 640 Z');
 const chestMask=union(chestLid,intersect(chestFlood,pathMask('M1443 640 H1672 V788 H1443 Z')));
 const lanternMask=maskFromPixels(source,[1530,307,55,94],[[1554,326],[1544,350],[1556,387]],(r,g,b)=>r<155&&g>r*.75&&g>b*.9,1);
 const masks={sparky:union(characterMask,propMask,stickButt),bird:fullBird,fire:fireMask,chest:chestMask,lantern:lanternMask};
 const maskPixels=new Map(Object.entries(masks).map(([id,c])=>{
  const rgba=c.getContext('2d').getImageData(0,0,W,H).data,alpha=new Uint8Array(W*H);
  for(let i=0;i<alpha.length;i++)alpha[i]=rgba[i*4+3];
  return [id,alpha];
 }));
 const compactChest=layer(1443,547,229,241);
 compactChest.getContext('2d').drawImage(chestMask,0,0);
 masks.chest=compactChest;
 for(const [id,left,top,width,height]of [['lantern',1530,307,55,94]]){
  const compact=layer(left,top,width,height);compact.getContext('2d').drawImage(masks[id],0,0);masks[id]=compact;
 }
 function textureHit(c,x,y){
  const {left,top,texture,alpha}=textures.get(c);x=Math.floor(x-left);y=Math.floor(y-top);
  return x>=0&&y>=0&&x<texture.width&&y<texture.height&&alpha[y*texture.width+x]>80;
 }
 function inverse(x,y,cx,cy,angle){const dx=x-cx,dy=y-cy;return [cx+dx*Math.cos(angle)+dy*Math.sin(angle),cy-dx*Math.sin(angle)+dy*Math.cos(angle)];}
 function hit(id,x,y){
  if(id==='sparky'){
   x=665+(x-665)/(1+diagnostics.breathe*.28);y=653+(y-653)/(1+diagnostics.breathe);
   const head=inverse(x-diagnostics.headX,y-diagnostics.headY,659,505,diagnostics.headAngle);
   head[0]=659+(head[0]-659)/diagnostics.headScaleX;
   return actor.getContext('2d').isPointInPath(neckPath,x-actor.originX,y-actor.originY)||textureHit(bodySprite,x,y)||textureHit(headSprite,...head)||textureHit(freeArmSprite,...inverse(x,y-diagnostics.freeArmY,588,507,diagnostics.freeArmAngle))||textureHit(armSprite,...inverse(x,y,709,535,diagnostics.armAngle));
  }
  if(id==='bird')return textureHit(birdSprite,x,y)||textureHit(wingSprite,...inverse(x,y,173,516,diagnostics.wingAngle));
  const mask=maskPixels.get(id);return !!mask&&mask[Math.floor(y)*W+Math.floor(x)]>80;
 }
 // Release construction surfaces explicitly; only compact textures remain in the rig.
 const keep=new Set([source,base,...Object.values(masks)]);
 for(const c of constructionCanvases)if(!keep.has(c)){c.width=1;c.height=1;}
 constructionCanvases.length=0;
 return {frame,hit,diagnostics:()=>diagnostics,masks,source};
}
